import { createHelpDocApi } from '@eastcoal/api/content/helpDocOperation/createHelpDoc'
import { queryHelpDocApi } from '@eastcoal/api/content/helpDocOperation/queryHelpDoc'
import { updateHelpDocApi } from '@eastcoal/api/content/helpDocOperation/updateHelpDoc'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { useUrlParams } from '@eastcoal/common/hooks/useUrlParams'

import { CrudForm } from '@eastcoal/formily/components/CrudForm'
import { SubmitType } from '@eastcoal/formily/components/CrudForm/enums/SubmitType'
import { BackButton } from '@eastcoal/formily/components/CrudForm/shared/BackButton'
import { SaveButton } from '@eastcoal/formily/components/CrudForm/shared/SaveButton'
import { SubmitButton } from '@eastcoal/formily/components/CrudForm/shared/SubmitButton'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { RichEditor } from '@eastcoal/formily/components/RichEditor'

import { useNavigate } from '@eastcoal/router/exports/react-router'

import { HelpCatalogueCascader } from '../components/HelpCatalogueCascader'

import { HelpDocFormFormilyProps, HelpDocFormProps } from './interface'

const schema: HelpDocFormFormilyProps['schema'] = [
  {
    name: 'title',
    type: 'string',
    title: '文章标题',
    required: true,
    'x-component': Input,
    'x-decorator': FormItem,
    'x-decorator-props': {
      wrapperWidth: 480
    }
  },
  {
    name: '{ id: catalogueId, code: catalogueCode }',
    type: 'object',
    title: '所属目录',
    'x-component': HelpCatalogueCascader,
    'x-decorator': FormItem,
    'x-decorator-props': {
      wrapperWidth: 480
    }
  },
  {
    name: 'content',
    type: 'string',
    title: '文章内容',
    'x-component': RichEditor,
    'x-decorator': FormItem
  }
]

const readApi: HelpDocFormFormilyProps['readApi'] = ({ id }) => {
  return {
    ready: !!id,
    refreshDeps: [id],
    api: async () => queryHelpDocApi({ id })
  }
}

const createApi: HelpDocFormFormilyProps['createApi'] = (
  data,
  { submitType }
) => {
  return createHelpDocApi({
    ...data,
    status: submitType === SubmitType.SUBMIT ? 1 : 0
  })
}

const updateApi: HelpDocFormFormilyProps['updateApi'] = (
  data,
  { submitType }
) => {
  return updateHelpDocApi({
    ...data,
    status: submitType === SubmitType.SUBMIT ? 1 : 0
  })
}

const actions: HelpDocFormFormilyProps['actions'] = [
  <BackButton key='backButton' />,
  <SaveButton key='saveButton' />,
  <SubmitButton key='publishButton'>发布</SubmitButton>
]

export const HelpDocForm = (props: HelpDocFormProps) => {
  const { catalogueId, catalogueCode } = useUrlParams()

  const navigate = useNavigate()
  const { message } = useFeedback()

  const handleSubmitSuccess = () => {
    message.success('操作成功')
    navigate(-1)
  }

  return (
    <CrudForm
      {...props}
      actions={actions}
      createApi={createApi}
      name='articleForm'
      readApi={readApi}
      schema={schema}
      updateApi={updateApi}
      initialValues={{
        catalogueId,
        catalogueCode
      }}
      onSuccess={handleSubmitSuccess}
    />
  )
}
